import { render, staticRenderFns } from "./question-history.vue?vue&type=template&id=2dc528f0&scoped=true&"
import script from "./question-history.vue?vue&type=script&lang=js&"
export * from "./question-history.vue?vue&type=script&lang=js&"
import style0 from "./question-history.vue?vue&type=style&index=0&id=2dc528f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc528f0",
  null
  
)

export default component.exports